@use "styles" as *;
@use "sass:map";

$block: me-button;

.#{$block} {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: space(2);
  line-height: 1;
  font-weight: $font-weight-semi-bold;
  border: 1px solid transparent;
  border-radius: $border-radius;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background $transition-timing, color $transition-timing;

  &--hidden-submit &__submit {
    display: none;
  }

  &--inline {
    display: inline-flex;
  }

  &__spinner {
    transition: opacity $transition-timing;
    opacity: 0;
  }

  &--loading {
    .#{$block}__spinner {
      opacity: 1;
    }
  }

  &--icons {
    .#{$block}__icon {
      display: block;
    }
  }

  &--round {
    box-sizing: content-box;
    border-radius: 50%;
    aspect-ratio: 1;

    .#{$block}__label {
      display: block;
    }
  }

  @each $size, $size-options in $button-sizes {
    &--#{$size} {
      font-size: map.get($size-options, font-size);
      padding: space(map.get($size-options, padding-v), map.get($size-options, padding-h));

      &.#{$block}--round {
        width: calc(2 * map.get($size-options, padding-v) * $space + $fa-fw-width);
        padding: 0;
      }
    }

    &__icon {
      display: none;
      width: map.get($size-options, font-size);
      text-align: center;
    }

    @each $theme, $theme-options in $button-themes {
      &--#{$theme} {
        background: map.get($theme-options, background);
        color: map.get($theme-options, color);

        &:hover {
          background: map.get($theme-options, background-hover);
          color: map.get($theme-options, color-hover);
        }

        &[disabled]:not([disabled=false]) {
          background: $color-gray-200;
          border-color: $color-gray-200;
          color: $color-gray-400;
          cursor: not-allowed;
        }

        &.#{$block}--outline {
          background: transparent;
          border-color: map.get($theme-options, background);
          color: map.get($theme-options, background);

          &:hover {
            background: map.get($theme-options, background);
            color: map.get($theme-options, color);
          }

          &[disabled]:not([disabled=false]) {
            background: transparent;
            border-color: $color-gray-200;
            color: $color-gray-300;
            cursor: not-allowed;
          }
        }

        &.#{$block}--link {
          background: transparent;
          border-color: transparent;

          @if $theme == 'text' {
            &:hover {
              text-decoration: underline;
              background: transparent;

              &[disabled]:not([disabled=false]) {
                text-decoration: none;
              }
            }
          }
          @else {
            color: map.get($theme-options, background);

            &:hover {
              background: transparent;
              color: map.get($theme-options, background-hover);
            }
          }

          &[disabled]:not([disabled=false]) {
            background: transparent;
            border-color: transparent;
            color: $color-gray-300;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
